/***
 * Created on 2023/8/2
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
//import singleSpaReact from 'single-spa-react';
//import ReactDOMClient from 'react-dom/client';
import Security from "../component/security/security";
import {I18nextProvider} from "react-i18next";
import sharedI18n from "common/SharedI18n";

function SecurityWrapper() {
    return (
        <I18nextProvider i18n={sharedI18n} >
            <Security />
        </I18nextProvider>
    )
}
export default SecurityWrapper;
/*
const compLifeCycle = singleSpaReact({
    React,
    ReactDOM: null,
    ReactDOMClient,
    rootComponent: Security,
    renderType: 'createRoot',
    errorBoundary: (err, info, page) => {
        return (
            <section>
                <div>Security Component renders with error occurs.</div>
                <div>{err}</div>
                <div>{info}</div>
                <div>{page}</div>
            </section>
        )
    }
})

export const { bootstrap, mount, unmount } = compLifeCycle;

 */